import { PaginationTypes } from 'types/sharedResponse'
import { FieldType } from 'utils/atsUtils'
import { CompanyAboutInfo } from '../ATSPuplic/actions'
import { cvFileFields } from '../CandidateView/actions'
import { SuggestedLink } from './getSuggestedLinks/actions'

export const GET_OPEN_JOBS = 'GET_OPEN_JOBS'
export const GET_OPEN_JOBS_PENDING = 'GET_OPEN_JOBS_PENDING'
export const GET_OPEN_JOBS_FULFILLED = 'GET_OPEN_JOBS_FULFILLED'
export const GET_OPEN_JOBS_REJECTED = 'GET_OPEN_JOBS_REJECTED'

export type Candidate = {
  id: number
  name_ar: string
  name_en: string
  name_i18n: string
  comment_count?: number
  current_ctc?: number
  current_role?: string
  email: string
  file_url?: string
  cv_file_fields: cvFileFields
  expected_ctc?: number
  gender: 'Male' | 'Female'
  notice_period_days?: number
  phone_number: number
  work_experience?: number
  city_id?: number
  country_id?: number
  organization_id?: number
}

export type JobWorkFlowStage = {
  id?: number
  stage_name: string
  stage_name_i18n?: string
  round: number
  application_count?: number
}

export type CandidateProfileField = {
  name_en?: boolean
  name_ar?: boolean
  address?: boolean
  nationality_id?: boolean
  country_id?: boolean
  phone_number?: boolean
  current_role?: boolean
  email?: boolean
  links?: boolean
  cv_file?: boolean
  city?: boolean
}

export type ScreeningQuestionFieldData = {
  id: number
  title: string
  options?: string[]
  position: number
  is_required?: boolean
  question_type?: FieldType
}

export type ScreeningQuestionFields = {
  [x in FieldType]?: ScreeningQuestionFieldData[]
}

export type ScreeningQuestion = {
  question_id: number
  text?: string
  attachment?: {
    data: string
    filename: string
  }
}

export type JobFormDetails = {
  locale: 'en' | 'ar'
  candidate_profile_fields: CandidateProfileField
  screening_questions?: ScreeningQuestionFieldData[]
  candidate_link_types: SuggestedLink[]
}

export type Job = {
  id: number
  title_en: string
  title_ar: string
  title_i18n: string
  status: string
  status_i18n: string
  guid?: number
  description?: string
  organization_id?: number
  closing_round?: number
  employment_type_id?: number
  created_by_id?: number
  business_unit_id?: number
  job_workflow_stages: JobWorkFlowStage[]
  job_workflow_stages_attributes?: JobWorkFlowStage[]
  department_id?: number
  location_id?: number
  updated_at?: string
  created_at?: string
  job_code?: number
  file_url?: string
  is_shareable?: boolean
  company_about_info?: CompanyAboutInfo
  file?: {
    data: string
    filename: string
  }
  job_form?: JobFormDetails
  total_candidates?: number
}

export type GetAllJobResponse = {
  data: {
    jobs: Job[]
    open_jobs: number
    skip_onboarding?: boolean
  }
  pagination: PaginationTypes
  success?: boolean
  statusCode?: number
}

export type OpenJob = {
  id: number
  title_en: string
  title_ar: string
  title_i18n: string
}
